import React from 'react';
import { DatePicker, Radio, Space } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';

const {RangePicker} = DatePicker;

class DateRangePicker extends React.Component {
  static TODAY = [moment(), moment()];
  static YESTERDAY = [moment().subtract(1, 'days'), moment().subtract(1, 'days')];

  static LAST_WEEK = [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'weeks').endOf('week')];
  static THIS_WEEK = [moment().startOf('week'), moment()];
  static LAST_MONTH = [moment().subtract(1, 'months').startOf('month'), moment().subtract(1, 'months').endOf('month')];
  static THIS_MONTH = [moment().startOf('month'), moment()];

  static RECENT_7_DAYS = [moment().subtract(6, 'days').subtract(-1, 'milliseconds'), moment()];
  static RECENT_30_DAYS = [moment().subtract(29, 'days').subtract(-1, 'milliseconds'), moment()];

  onChange = (value) => {
    this.props.onChange?.(value);
  }

  onRadioButtonChange = (e) => {
    this.props.onChange?.(e.target.value);
  }

  render() {
    const radioButtonStyle = {paddingLeft: 8, paddingRight: 8};
    return <Space size='middle'>
      <RangePicker allowClear={false} value={this.props.value} onChange={this.onChange} style={{width: 220}}/>
      <Radio.Group buttonStyle='solid' value={this.props.value} onChange={this.onRadioButtonChange}>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.TODAY}>今天</Radio.Button>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.YESTERDAY}>昨天</Radio.Button>
      </Radio.Group>
      <Radio.Group buttonStyle='solid' value={this.props.value} onChange={this.onRadioButtonChange}>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.LAST_WEEK}>上周</Radio.Button>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.THIS_WEEK}>本周</Radio.Button>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.LAST_MONTH}>上月</Radio.Button>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.THIS_MONTH}>本月</Radio.Button>
      </Radio.Group>
      <Radio.Group buttonStyle='solid' value={this.props.value} onChange={this.onRadioButtonChange}>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.RECENT_7_DAYS}>近7天</Radio.Button>
        <Radio.Button style={radioButtonStyle} value={DateRangePicker.RECENT_30_DAYS}>近30天</Radio.Button>
      </Radio.Group>
    </Space>
  }
}

export default DateRangePicker;